import { stringToBoolean } from "@/lib/chillnn/string-to-boolean";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { FormErrorMessage, FormItem } from "@/components/ui/form/_base/form";
import { RadioGroupField } from "@/components/ui/form/fields/radio-field/radio-group";

import { KidsPolicyCalculationDemo } from "./components";
import { useKidsPolicyDetailOfHotelPolicy } from "./hooks";

export const QuestionHotelPolicyKidsPolicyDetail = () => {
	const { calcAdultPriceAsTotalNum, updateCalcAdultPriceAsTotalNum } = useKidsPolicyDetailOfHotelPolicy();

	const options = [
		{
			id: "calcAdultPriceAsTotalNum#1",
			label: "大人の人数の料金を基準にする [一般的な設定]",
			value: "false",
		},
		{
			id: "calcAdultPriceAsTotalNum#2",
			label: "合計人数の料金を基準にする",
			value: "true",
		},
	];

	const handleValueChange = (value: string) => {
		const booleanValue = stringToBoolean(value);

		updateCalcAdultPriceAsTotalNum(booleanValue);
	};

	return (
		<div className="space-y-8">
			<FeatureIslandCategoryQuestionForMain
				required={false}
				title={"キッズポリシーの計算方法"}
				isEdited={calcAdultPriceAsTotalNum.isEdited}
				hasError={Boolean(calcAdultPriceAsTotalNum.error)}
				inputChildren={
					<FormItem>
						<div className="flex flex-col gap-y-6">
							<RadioGroupField
								value={String(calcAdultPriceAsTotalNum.value)}
								handleValueChange={handleValueChange}
								options={options}
							/>
						</div>
						<FormErrorMessage>{calcAdultPriceAsTotalNum.error}</FormErrorMessage>
					</FormItem>
				}
			/>
			{/* キッズポリシー計算デモ用のコンポーネント */}
			<KidsPolicyCalculationDemo calcAdultPriceAsTotalNum={calcAdultPriceAsTotalNum.value} />
		</div>
	);
};

QuestionHotelPolicyKidsPolicyDetail.displayName = "QuestionHotelPolicyKidsPolicyDetail";
